import React from 'react';
import { View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import useTranslation from '@/hooks/useTranslation';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import Button from '@/components/Buttons/Button';
import { getCatalogPalette } from '@/components/Catalog/catalogPalette';

function TasksFavoritesEmptyState({ variant = 'none', onBrowseTemplates }) {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const palette = getCatalogPalette(theme);
  const isCategory = variant === 'category';
  return <View style={{ alignItems: 'center', padding: 28, gap: 12, borderRadius: 18, borderWidth: 1, borderColor: palette.border, backgroundColor: palette.surface }}>
    <View style={{ width: 44, height: 44, borderRadius: 12, backgroundColor: palette.preview, alignItems: 'center', justifyContent: 'center' }}>
      <Icon name="heart" size={20} color={palette.icon} />
    </View>
    <Text size="l" weight="semibold" style={{ textAlign: 'center' }}>{t(isCategory ? 'pages.tasks.favoritesEmptyCategoryTitle' : 'pages.tasks.favoritesEmptyTitle')}</Text>
    <Text size="s" color="secondary" style={{ maxWidth: 420, textAlign: 'center', lineHeight: 21 }}>{t(isCategory ? 'pages.tasks.favoritesEmptyCategorySubtitle' : 'pages.tasks.favoritesEmptySubtitle')}</Text>
    <Button text={t(isCategory ? 'pages.tasks.favoritesEmptyBrowseAll' : 'pages.tasks.browseTemplates')} variant="secondary" onPress={onBrowseTemplates} />
  </View>;
}

export default React.memo(TasksFavoritesEmptyState);
